var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transactions',{attrs:{"transaction-class":_vm.transactionClass,"verbose-name":JSON.parse(_vm.$route.params.sales) ? 'Bon de commande' : 'Ordre d\'achat',"verbose-name-plural":JSON.parse(_vm.$route.params.sales) ? 'Bons de commande' : 'Ordres d\'achats',"ressource":"purchase-orders","colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }